/** 查看用户资质信息（身份证、手机号等敏感信息） */
export const ROLE_USER_QUALIFICATION_VIEW = 'ROLE_USER_QUALIFICATION_VIEW';

export const ROLE_ADMIN = 'ROLE_ADMIN';

export const ROLE_MERCHANT_ADMIN = 'ROLE_MERCHANT_ADMIN';

const PERMISSIONS_KEY = 'permissions';
const ROLES_KEY = 'roles';

function readStringList(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return [];
    }
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : [];
  } catch {
    return [];
  }
}

export function getRolesFromStorage(): string[] {
  return readStringList(ROLES_KEY);
}

export function getPermissionsFromStorage(): string[] {
  return readStringList(PERMISSIONS_KEY);
}

export function savePermissions(permissions: string[] | undefined): void {
  if (permissions && permissions.length > 0) {
    localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions));
  } else {
    localStorage.removeItem(PERMISSIONS_KEY);
  }
}

export function clearAuthStorage(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  localStorage.removeItem(ROLES_KEY);
  localStorage.removeItem(PERMISSIONS_KEY);
}

export function hasRole(role: string): boolean {
  return getRolesFromStorage().includes(role);
}

export function hasPermission(permission: string): boolean {
  return getPermissionsFromStorage().includes(permission);
}

export function hasAnyPermission(permissions: string[]): boolean {
  const owned = getPermissionsFromStorage();
  return permissions.some((permission) => owned.includes(permission));
}
